import React from "react";
import { Navigate, Outlet } from "react-router-dom";

export const RedirectPanel = ({  children,redirectTo = "/home",}) => {
  const token = localStorage.getItem("token_arteonu");

  if ( token) {
    return <Navigate to={redirectTo} />;
  }
  return children ? children : <Outlet />;
};

export const RedirectLogin = ({ children, redirectTo = "/",}) => {
  
  const token = localStorage.getItem("token_arteonu");
  const user = JSON.parse(localStorage.getItem("user_arteonu") || "{}");

  if (!token || !user.verified) {
    return <Navigate to={redirectTo} />;
  }
  return <Outlet />;
};

